// CS 21.55 — ASHTH LITE detection helper (frontend mirror of backend
// `pricing.is_ashth_lite_product`). Precedence:
//   1. Explicit `is_ashth_lite === true | false` wins.
//   2. Missing / null / undefined -> auto-detect via strict AL prefix rule.
//      Trim + uppercase the code; match ONLY when it starts with `AL-`
//      OR `AL ` (i.e. AL followed by a hyphen or space).
//      Codes like `ALLOY-01`, `ALR-99`, `ALPHA`, `AL001`, plain `AL`
//      are NOT matched.
//
// CS 21.68 — Read `style_no` FIRST. The AL prefix lives on the
// product/style code, not the jewel_code (piece serial like `26P1308`)
// or item_code (metal code like `G18KTY`).
export const AL_PREFIX_RE = /^AL[-\s]/;

export function isAshthLiteProduct(product) {
  if (!product) return false;
  const manual = product.is_ashth_lite;
  if (manual === true) return true;
  if (manual === false) return false;
  for (const k of ["style_no", "style_code", "product_code", "jewel_code"]) {
    const v = product[k];
    if (v && AL_PREFIX_RE.test(String(v).trim().toUpperCase())) return true;
  }
  return false;
}

// CS 21.80 — AL-series VISIBILITY detector (frontend mirror of backend
// `pricing.is_al_series`). Deliberately BROADER than the pricing badge
// rule above: any style/product code starting with "AL" counts, with or
// without a hyphen/space separator (AL-RF23032-0025Y9 and ALEF11208-0030Y9
// both match). Prefix-only — the manual is_ashth_lite toggle governs
// pricing, not visibility. Used ONLY to drive final-price-only rendering;
// it never changes pricing math.
export const AL_SERIES_RE = /^AL/i;

export function isAlSeries(product) {
  if (!product) return false;
  for (const k of ["style_no", "style_code", "product_code", "jewel_code"]) {
    const v = product[k];
    if (v && AL_SERIES_RE.test(String(v).trim().toUpperCase())) return true;
  }
  return false;
}

// CS 21.83 (APS v5) — canonical EFFECTIVE Ashth Lite decision (frontend
// mirror of backend `pricing.is_al_effective`). Precedence (user-confirmed):
//   1. `is_ashth_lite === true`  -> AL treatment regardless of code.
//   2. `is_ashth_lite === false` -> non-AL treatment even on AL-prefixed code.
//   3. unset -> broad AL prefix detection (`isAlSeries`).
// Badge, final-price-only rendering and engine dispatch all use THIS one
// decision so display classification can never disagree with itself.
export function isAlEffective(product) {
  if (!product) return false;
  const manual = product.is_ashth_lite;
  if (manual === true) return true;
  if (manual === false) return false;
  return isAlSeries(product);
}
